import { render } from "./DispatcherInformationModal.vue?vue&type=template&id=6904360f&scoped=true"
import script from "./DispatcherInformationModal.vue?vue&type=script&lang=js"
export * from "./DispatcherInformationModal.vue?vue&type=script&lang=js"

import "./DispatcherInformationModal.vue?vue&type=style&index=0&id=6904360f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6904360f"]])

export default __exports__